const ALL_ROLES: string[] = ["Master Admin","Technology Admin", "Region Admin", "Engineer", "CPI", "Installer"];

export default ALL_ROLES;